import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { listHorses } from '../../apollo/queries/listHorses'
import Pagination from '../../components/Pagination/Pagination'
import HorsesTable from '../../components/HorsesTable'
import FormInput from '../../components/atoms/Input/Form-Input'
import { horseStatus } from '../../utils'
import { useNavigate } from 'react-router-dom'
import MainLayout from '../../components/Layout'

function HorseAdmin() {
  const navigate = useNavigate()
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null })

  const [searchQuery, setSearchQuery] = useState('')
  const [statusFilter, setStatusFilter] = useState([])

  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  const { data, loading } = useQuery(listHorses, {
    fetchPolicy: 'network-only',
  })

  const horses = data?.listHorses?.items || []
  const filteredHorses = horses.filter(horse => {
    const matchesSearch = horse?.name
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase())
    const matchesStatus =
      statusFilter.length > 0 ? statusFilter.includes(horse?.status) : true
    return matchesSearch && matchesStatus
  })

  const paginatedHorses = React.useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    return filteredHorses.slice(startIndex, endIndex)
  }, [filteredHorses, currentPage])

  const totalPages = Math.ceil(filteredHorses.length / itemsPerPage)

  const loadNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1)
    }
  }

  const loadPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1)
    }
  }

  const handleSort = key => {
    setSortConfig(prevConfig => {
      const direction =
        prevConfig?.key === key && prevConfig?.direction === 'ascending'
          ? 'descending'
          : 'ascending'
      return { key, direction }
    })
  }

  return (
    <MainLayout>
      <div className="flex flex-col mb-4 md:mb-0 md:flex-row items-start md:items-center justify-between gap-y-4 w-full">
        <h1 className="admin-dashboard">Admin Horses</h1>
        <div className="flex flex-wrap sm:flex-nowrap gap-4 w-full md:w-auto">
          <div className="flex-1 min-w-[160px] sm:max-w-[240px]">
            <FormInput
              name="search"
              label="Search"
              type="text"
              placeholder="Search by Name..."
              onChange={e => setSearchQuery(e.target.value)}
              className="w-full"
            />
          </div>
          <div className="flex-1 min-w-[160px] sm:max-w-[240px]">
            <FormInput
              isMulti
              name="status"
              type="select2"
              label="Status"
              height={52}
              placeholder="Select Status"
              options={horseStatus}
              onChange={options =>
                setStatusFilter(options ? options.map(opt => opt.value) : [])
              }
              className="w-full"
            />
          </div>
        </div>
      </div>

      <HorsesTable
        loading={loading}
        horses={paginatedHorses}
        sortConfig={sortConfig}
        handleSort={handleSort}
        onEdit={horse =>
          navigate(`/horse-admin/horse/edit/${horse?.id}`, {
            state: { horse },
          })
        }
        onChangeOwnership={horse =>
          navigate(`/horse-admin/horse/transferOwnership/${horse?.id}`, {
            state: { horse },
          })
        }
      />

      <Pagination
        loadNextPage={loadNextPage}
        loadPreviousPage={loadPreviousPage}
        canLoadNext={currentPage < totalPages}
        canLoadPrevious={currentPage > 1}
      />
    </MainLayout>
  )
}

export default HorseAdmin
